<template>
	<textarea
		v-model.trim="inputValue"
		:name="name"
		:id="id"
		:cols="cols"
		:rows="rows"
		:placeholder="placeholder"
		:required="requiredLive"
		:class="inputClassListLive"
		:readonly="readonlyLive"
		:disabled="disabledLive"
		:resizeable="false"
		:style="{ resize: resizeable ? `auto` : `none`}"

		@input="onInputHandler"
		@change="onChangeHandler"
		@focus="onFocusHandler"
		@blur="onBlurHandler"
	>
	</textarea>
</template>

<script>
	import { baseInput } from './../mixins/index.js';

	export default {
		name: 'Textarea',

		mixins: [baseInput],

		props: {
			cols: { type: Number, required: false, default: 30 },
			rows: { type: Number, required: false, default: 4 },
			resizeable: { type: Boolean, required: false, default: false }
		}

	};
</script>
